export const truncateText = (text, symbolCount) => {
  if (!text) return '';

  const substring = text.substring(0, symbolCount);

  return text.length <= symbolCount ? text : `${substring}...`;
};
